export default __webpack_public_path__ + "static/media/share-arrow.bbafc990.svg";